import { render, staticRenderFns } from "./unqualifiedDamageList.vue?vue&type=template&id=24a51d71&scoped=true"
import script from "./unqualifiedDamageList.vue?vue&type=script&lang=js"
export * from "./unqualifiedDamageList.vue?vue&type=script&lang=js"
import style0 from "./unqualifiedDamageList.vue?vue&type=style&index=0&id=24a51d71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a51d71",
  null
  
)

export default component.exports